var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSittingGuy(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 266,
    height: 367,
    viewBox: "0 0 266 367",
    className: "img sitting-guy",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}.b{fill:none;}.c{clip-path:url(#a);}.d{fill:#9a9a9a;}.e{fill:#838383;}.f{clip-path:url(#b);}.g{fill:#8b5eba;}.h{fill:#6b429a;}.i{clip-path:url(#c);}.j{fill:#282829;}.k{clip-path:url(#d);}.l{fill:#33c595;}.m{fill:#cacaca;}.n{fill:#248762;}.o{fill:#47484a;}.p{fill:#2dab7f;}.q{fill:#1e7250;}.r{fill:#f0d5bf;}.s{clip-path:url(#e);}.t{clip-path:url(#f);}.u{fill:#e6c1b1;}.v{fill:#61daae;}.w{clip-path:url(#h);}.x{fill:#f3d8c2;}.y{fill:#e9c4b4;}.z{fill:#cda192;}.aa{fill:#4b4b4d;}.ab{fill:#f5911e;}.ac{fill:#f3ac67;}.ad{fill:#cbcbcb;}.ae{clip-path:url(#j);}.af{fill:url(#k);}.ag{fill:#76859c;}.ah{fill:#bababa;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 266,
    height: 367,
    transform: "translate(704.143 463)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "b"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "b",
    width: 111.547,
    height: 20.782,
    rx: 4.668,
    transform: "translate(0)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "c"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "b",
    width: 263.567,
    height: 340.5
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "d"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M198.135,381.5l-71.18,6.142L95.406,496.516S51,503.445,50,514.206h62.414l18.845-46.3a277.9,277.9,0,0,0,16.168-56.115s40.577,65.669,42.992,88.87c0,0-38.162,10.079-37.427,18.005h59.317s-10.394-74.54-29.134-102.309h85.248s12.493-3.465,10.761-17.323C277.924,388.853,246.8,375.1,221.6,375.1c-9.186,0-17.585,1.837-23.464,6.352",
    transform: "translate(-50 -375.1)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "e"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M336.452,303.521,332.2,334.282s31.811-9.711,51.653,3.937,32.808,16.43,30.026,26.351c0,0,5.144-8.766.367-21.942s2.625-55.222.787-65.2c-.21-1.207-1.522-1.732-3.674-1.732-15.643,0-74.96,27.874-74.96,27.874",
    transform: "translate(-332.2 -275.7)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "f"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M275.653,159.512c-24.672,3.15-30.183,33.333-30.183,33.333-13.648,68.241-71.915,56.692-71.915,56.692-6.876-.105-5.617,1.68.053,3.412,9.239,2.887,30.131,5.722,46.4.525,26.246-8.4,40.419-49.343,40.419-49.343L258.855,247.7s-61.417,8.924-24.147,9.449,81.889-3.675,97.112-15.223,6.824-58.267,0-70.865c-5.039-9.239-19.685-12.861-36.9-12.861a153.757,153.757,0,0,0-19.265,1.312",
    transform: "translate(-168.863 -158.2)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "h"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M346.5,19.379c-7.244,15.275-.682,25.407-5.092,31.968s-5.774,6.824-1.995,8.241,5.932.1,5.932.1,6.877,25.459,13.228,25.039a9.192,9.192,0,0,0,5.3-1.68,1,1,0,0,1,1.627.735c.42,6.509,2.047,21.365,8.766,19.16,8.556-2.835,1-29.763,1-29.763a192.209,192.209,0,0,0,6.4-19.475c.367-1.312,3.36-1.785,3.937-3.045,2.625-5.407-.157-8.346.21-10.236.735-3.727-.472-4.987-.367-7.926.315-13.176-12.756-21.1-24.147-21.1-6.4,0-12.231,2.52-14.856,8.031",
    transform: "translate(-337.208 -11.4)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "j"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M111.8,258.3a2.52,2.52,0,0,0-2.415,3.307l14.96,45.144a4.042,4.042,0,0,0,3.832,2.782h63.359l-16.22-48.818a3.517,3.517,0,0,0-3.307-2.415Z",
    transform: "translate(-109.26 -258.3)"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "k",
    cx: 0.492,
    cy: 0.385,
    r: 0.933,
    gradientTransform: "matrix(0, 1, 0.723, 0, -2.919, 3.813)",
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#dce6e9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e0e5e4"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "c",
    transform: "translate(-704.143 -463)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(851.79 663.847)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-131.783 -170.25)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "d",
    width: 8.661,
    height: 76.54,
    transform: "translate(200.733 259)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "e",
    width: 8.661,
    height: 9.512,
    transform: "translate(200.733 259)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "f",
    transform: "translate(152.019 238.213)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M395.426,474.587h-100.1a5.722,5.722,0,0,1-5.722-5.722v-9.344a5.722,5.722,0,0,1,5.722-5.722h100.1a5.722,5.722,0,0,1,5.722,5.722v9.344a5.722,5.722,0,0,1-5.722,5.722",
    transform: "translate(-289.6 -453.8)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M318.044,470.185,307.65,455.435s62.309.525,75.485-6.667-93.91-3.045-93.91-3.045l-.525,15.7,4.829,11.076,17.953,3.937Z",
    transform: "translate(-289.172 -449.398)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "i",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M479.486,435.974s-3.832,4.514-8.084,2.887S475.444,426,475.444,426s7.559,1.68,4.042,9.974",
    transform: "translate(-223.374 -202.38)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "k",
    transform: "translate(26.246 196.901)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M198.135,381.56l-71.18,6.142L95.406,496.572S51,503.5,50,514.262h62.414l18.845-46.3a277.9,277.9,0,0,0,16.168-56.115S188,477.517,190.418,500.719c0,0-38.162,10.078-37.427,18h59.317s-10.394-74.54-29.134-102.309h85.248s12.493-3.464,10.761-17.323-59.107-34.383-81.049-17.533",
    transform: "translate(-50 -375.156)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "m",
    d: "M277.885,612s15.485,8.136,17.848,5.249a14.644,14.644,0,0,0,2.94-5.249l6.457,20.262H238.2s6.929-18.005,39.685-20.262",
    transform: "translate(-139.408 -487.644)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M143.952,410.985s-12.546-16.64-10.184-18.95c12.231-11.811,93.857-4.094,98.372-6.719s-15.7-4.042-8.766-3.884,15.433,1.365,23.727,8.819,16.273,6.614,17.848,9.029,7.454,12.283-7.3,16.273l14.908,2.257,4.672-14.225L247.573,373.4H186.419L120.54,385.263,85.685,493.451s-42.152,8.346-42.992,18.53,71.233,5.879,71.233,5.879l31.548-99.684Z",
    transform: "translate(-46.525 -374.292)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "o",
    d: "M113.478,612.72s-8.556.577-11.916-1.05-3.884-5.932-10.026-5.774-51.443.473-48.556,18.53l14.7,2.52,54.33-2.31Z",
    transform: "translate(-46.602 -484.743)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "p",
    d: "M303.6,453.8s16.273,50.183,14.331,52.808-9.816,3.359-4.724,4.409,12.493.787,7.611,3.57-3.675,4.829-.682,5.2,2.257,18.372,2.257,18.372h7.4L313.311,453.8Z",
    transform: "translate(-170.478 -412.488)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "q",
    d: "M204.388,430.558,194.414,414.6l1.837,9.5a31.916,31.916,0,0,1-.157,12.913l-4.252,19.265a39.421,39.421,0,0,1-10.551,19.265l-2.73,2.73s8.346,5.564,3.989,6.247-12.283-.525-7.611,1.89,8.136,6.089,4.829,6.089-9.869,25.511-9.869,25.511l5.722,3.307s25.144-57.742,25.669-58.425,3.1-32.388,3.1-32.388",
    transform: "translate(-106.961 -393.865)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M136.645,588.4l25.721,5.827-4.672,10.236s-11.5,1.837-17.375-2.992-6.719-3.57-6.719-3.57Z",
    transform: "translate(-89.716 -476.433)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M316.407,607.269s13.176,7.087,16.115,5.564,2.782-5.407,2.782-5.407L335.2,599.5l-20,2.94Z",
    transform: "translate(-175.989 -481.706)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "p",
    d: "M292.078,441.438s-15.538-14.121-12.283-13.648,9.711,9.449,10.656,5.669,1.207-5.879,3.359-3.569,10.971,9.239,37.532,9.239,53.333-1.365,53.333-1.365l-7.086,5.564Z",
    transform: "translate(-158.956 -400.126)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "s",
    transform: "translate(174.381 144.723)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "o",
    d: "M336.452,303.513,332.2,334.274s31.811-9.711,51.653,3.937,32.808,16.43,30.026,26.351c0,0,5.144-8.766.367-21.942s2.625-55.223.787-65.2S336.4,303.565,336.4,303.565",
    transform: "translate(-332.2 -275.692)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M337.8,320.006s44.357,10.393,58.425,2.52.945,9.029-11.338,8.084,3.255,4.829,9.5,6.037,6.719,10.656-2.992,5.984-11.076-.84-11.076-.84l41.574,33.018-2.94-84.408-32.913,18.267Z",
    transform: "translate(-334.86 -282.684)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "t",
    transform: "translate(88.641 83.044)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "o",
    d: "M331.32,190.483l-31.076,34.383L249.8,228.7l1.575-43.569-10.6,9.554-7.559-8.451L149.8,203.343V118.2H368.7Z",
    transform: "translate(-159.807 -139.197)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M305.8,289.708s52.65-6.352,58.32-14.908,5.3-28.084,5.3-28.084,12.7-1.155,17.9,4.724c0,0,6.142,26.141-10.866,36.062s-74.54,16.063-92.23,13.753-16.535-3.832-16.535-3.832,5.827-4.409,38.11-7.769",
    transform: "translate(-215.804 -200.208)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M256.528,245.7a23.577,23.577,0,0,1-18.163,1.1s-14.8,30.971-38.53,36.85-37.952.892-39.16,7.821,38.477,13.333,54.96,5.354,26.351-13.281,31.548-23.727,9.4-27.4,9.4-27.4",
    transform: "translate(-164.961 -199.769)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "u",
    d: "M272.8,245.653s-6.3,2.677-10.079,2.415c0,0-5.092,25.826-20.1,36.588S194.9,296.571,194.9,296.571a48.457,48.457,0,0,0,30.026,1.365c16.378-4.619,28.976-10.289,33.28-17.48S272.8,245.6,272.8,245.6",
    transform: "translate(-181.233 -199.721)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "u",
    d: "M283.553,300.528s93.175-3.254,101.259-20.577S389.64,249.4,389.64,249.4a13.938,13.938,0,0,1,5.2,3.412c1.837,2.2,10.866,37.742-18.792,42.992s-92.545,4.724-92.545,4.724",
    transform: "translate(-223.324 -201.527)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M440.454,231.313s-1.365-12.021-3.464-17.113c0,0,2.257,39.055-8.766,45.984L417.2,267.113s17.48-3.675,19.737-9.606,3.1-4.829,3.57-26.194",
    transform: "translate(-286.841 -184.804)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M388.213,169.2s-11.443,23.884-2.887,20.892,13.333-15.275,13.333-15.275Z",
    transform: "translate(-270.19 -163.426)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "i",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M165.568,583.912,135.7,576.3l2.94-11.6,29.186,10.184Z",
    transform: "translate(-64.467 -268.273)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "v",
    d: "M333.461,588.3l-25.2,3.727-1.365-9.134,22.729-6.194Z",
    transform: "translate(-145.799 -273.974)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "w",
    transform: "translate(177.01 5.984)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "x",
    width: 78.162,
    height: 111.652,
    transform: "translate(-26.363 -5.38) rotate(-11.1)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "y",
    d: "M352.553,99.837l2.625-3.937s1.68,14.436.787,15.748S352.5,99.784,352.5,99.784",
    transform: "translate(-344.473 -51.544)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "y",
    d: "M359.815,74.475s4.987-4.619,13.438-34.8C380.183,14.948,343.7,17.415,343.7,17.415s1-35.485,29.448-23.989,16.378,54.8,16.378,54.8l-4.357,47.506L373.358,99.2Z",
    transform: "translate(-340.292 -1.772)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "z",
    d: "M387.3,140.936s6.877-5.722,7.559-8.136c0,0-4.672,16.85,2.52,30.236l-7.192-1.995Z",
    transform: "translate(-361.005 -69.074)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "z",
    d: "M420.892,75.562s1.1-6.614,2.152-5.564,2.2,7.244-.1,7.716-2.047-2.152-2.047-2.152",
    transform: "translate(-376.959 -39.184)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "aa",
    d: "M368.88,75.716c.945,0,1.732-1.627,1.732-3.622s-1,1.1-1.942,1.1-1.47-3.1-1.47-1.1.735,3.622,1.68,3.622",
    transform: "translate(-351.456 -39.916)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "aa",
    d: "M355.58,75.616c.945,0,1.732-1.627,1.732-3.622s-1,1.1-1.942,1.1-1.47-3.1-1.47-1.1.735,3.622,1.68,3.622",
    transform: "translate(-345.138 -39.868)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "i",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "ab",
    d: "M342.87,54.257s8.189-6.037,16.483,2.94c0,0,16.43-7.139,14.436-20.315S368.119,13,348.067,16.934,330.8,5.281,335.521,4.546s43.412-15.275,47.559,11.548.157,29.081.157,29.081,1.522-15.223-3.2-11.811-2.992,10.971-2.415,13.123,2.625,14.278,1.417,16.483-15.853,19.107-25.2,18.845S342.87,54.2,342.87,54.2",
    transform: "translate(-157.78 0.021)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ac",
    d: "M345.1,7.731c0-1.312,12.6-3.884,22.624-3.832s13.753,2.73,13.753,4.042-8.136,2.362-18.215,2.31S345.1,9.044,345.1,7.731",
    transform: "translate(-163.947 -1.852)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "x",
    d: "M365.254,109.7a17.818,17.818,0,0,1-9.554,3.937s1.1,2.782,4.777,1.89,4.777-5.827,4.777-5.827",
    transform: "translate(-168.983 -52.115)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ab",
    d: "M363.946,62.705l7.821-1.522a.735.735,0,0,0,.577-.84l-.315-1.575a.735.735,0,0,0-.84-.577l-7.821,1.522a.735.735,0,0,0-.577.84l.315,1.575a.735.735,0,0,0,.84.577",
    transform: "translate(-172.347 -27.64)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ab",
    d: "M344.446,66.505l7.821-1.522a.735.735,0,0,0,.577-.84l-.315-1.575a.735.735,0,0,0-.84-.577l-7.821,1.522a.735.735,0,0,0-.577.84l.315,1.575a.735.735,0,0,0,.84.577",
    transform: "translate(-163.083 -29.445)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M326.815,227.172l.945-20.472s-1.47,17.27-19.16,21.575c0,0,5.039,4.042,11.076,1.995s7.086-3.1,7.086-3.1",
    transform: "translate(-146.607 -98.197)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ad",
    d: "M250.96,345.5H144.4v5.459H245.554a5.459,5.459,0,0,0,5.459-5.459",
    transform: "translate(-68.6 -164.137)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "ae",
    transform: "translate(57.353 135.589)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "af",
    width: 90.707,
    height: 65.621,
    transform: "translate(-9.605 1.696) rotate(-10.7)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "i",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M179.394,296.9a.735.735,0,0,0-.682.892,3.57,3.57,0,0,1-.42,2.1,2.047,2.047,0,0,1-1.732,1.05,3.465,3.465,0,0,1-2.257-.892A6.091,6.091,0,0,1,172.727,298a1.312,1.312,0,0,0-1.155-.787h0a.682.682,0,0,0-.63.42,1.05,1.05,0,0,0,.053.84,8.189,8.189,0,0,0,2.572,3.307l.892.577h0l-.577.63a4.934,4.934,0,0,0-.735,3.412,1.417,1.417,0,0,0,.42.84,1.155,1.155,0,0,0,.84.367.735.735,0,0,0,.682-.84,3.57,3.57,0,0,1,.42-2.1,2.047,2.047,0,0,1,1.732-1.05,3.465,3.465,0,0,1,2.257.892,6.038,6.038,0,0,1,1.575,2.047,1.313,1.313,0,0,0,1.155.787h0a.683.683,0,0,0,.63-.42,1.05,1.05,0,0,0-.052-.84,8.242,8.242,0,0,0-2.572-3.307l-.892-.577h0a3.462,3.462,0,0,0,.577-.63,4.881,4.881,0,0,0,.735-3.412,1.365,1.365,0,0,0-.42-.84,1.155,1.155,0,0,0-.84-.368",
    transform: "translate(-81.18 -141.049)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ag",
    d: "M276.289,350.679h-2.467a.577.577,0,1,1,0-1.1h2.467a.577.577,0,1,1,0,1.1",
    transform: "translate(-129.729 -166.061)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ag",
    d: "M285.589,350.679h-2.467a.577.577,0,1,1,0-1.1h2.467a.577.577,0,1,1,0,1.1",
    transform: "translate(-134.147 -166.061)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "d",
    width: 8.661,
    height: 136.061,
    transform: "translate(91.443 199.473)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "e",
    width: 8.661,
    height: 16.913,
    transform: "translate(91.443 199.473)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ah",
    d: "M177.989,622.7H87.072a4.672,4.672,0,1,0,0,9.344h90.918a4.672,4.672,0,1,0,0-9.344",
    transform: "translate(-39.146 -295.827)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M187.977,368.5H3.57A3.57,3.57,0,0,1,0,364.934V359.37a3.57,3.57,0,0,1,3.57-3.57H187.977a3.57,3.57,0,0,1,3.57,3.57v5.564a3.57,3.57,0,0,1-3.57,3.569",
    transform: "translate(0 -169.03)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "d",
    width: 8.661,
    height: 136.061,
    transform: "translate(91.443 199.473)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "e",
    width: 8.661,
    height: 16.913,
    transform: "translate(91.443 199.473)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ah",
    d: "M177.989,622.7H87.072a4.672,4.672,0,1,0,0,9.344h90.918a4.672,4.672,0,1,0,0-9.344",
    transform: "translate(-39.146 -295.827)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ah",
    d: "M390.79,622.7H299.872a4.672,4.672,0,1,0,0,9.344H390.79a4.672,4.672,0,0,0,0-9.344",
    transform: "translate(-140.241 -295.827)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "o",
    d: "M283.627,614.253s-36.273,1.522-37.427,18.005h59.317l-2.94-17.9s.42,4.462-6.719,4.252A21.678,21.678,0,0,1,283.68,614.2",
    transform: "translate(-116.963 -291.789)"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSittingGuy);
export default __webpack_public_path__ + "static/media/sitting-guy.9cfd5585773c8556e00eea156f9d0b86.svg";
export { ForwardRef as ReactComponent };